import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateLogEntryCache,
  LogEntryCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/logEntryCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type useLogEntryAiSubmitParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};

export const useLogEntryAiSubmit = (params?: useLogEntryAiSubmitParams) =>
  useMutation(Api.saveAiLogEntries, {
    ...params?.config,
    onSuccess: async (_, mutationFuncParams) => {
      const { organizationId, projectId, logId } = mutationFuncParams;

      const keyParams = {
        organizationId,
        logId,
        projectId,
      };

      // Invalidate any cache that includes info about log entries
      invalidateLogEntryCache(LogEntryCacheEvents.CREATE, keyParams);

      return params?.config?.onSuccess?.(_, mutationFuncParams);
    },
  });
